import { motion } from 'framer-motion';
import ApplicationPreview from '../../components/ApplicationTrackingComps/ApplicationPreview';
import ApplicationProgressTracker from '../../components/ApplicationTrackingComps/ApplicationProgressTracker';
import AcademiaNotFound from '../../components/CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../components/CommonComps/Loadings/AcademiaLoading';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import { useAuthContext } from '../../contexts/AuthProvider';
import useApplicationStatusAction from '../../hooks/APIHooks/users/useApplicationStatusActions';
import { Associate } from '../../types/associates';

const ApplicationTracking = () => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();

  // integration of API hooks here 'd1132191-6327-4faa-9597-2b5ef7365995'
  const { getApplicationStatusHandler } = useApplicationStatusAction(
    currentUser ? (currentUser as Associate).uid : ''
  );

  console.log('APPLICATION STATUS: ', getApplicationStatusHandler.data?.data);

  // rendering application tracking page component here
  return (
    <motion.main
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: {
          ease: 'easeInOut',
          y: { duration: 0.5 },
        },
      }}
      className='font-lato w-[95%] md:w-4/5 2xl:w-3/5 max-w-[1500px] mx-auto py-5 space-y-10'
    >
      <PageTitle title='Application Tracking' />

      {getApplicationStatusHandler.isLoading ? (
        <AcademiaLoading />
      ) : getApplicationStatusHandler.isSuccess ? (
        <>
          <ApplicationProgressTracker
            registrationRequest={
              getApplicationStatusHandler.data.data.registration_request
            }
          />

          <ApplicationPreview
            applicationStatus={getApplicationStatusHandler.data.data}
          />
        </>
      ) : (
        <AcademiaNotFound message='No Application Found!' />
      )}
    </motion.main>
  );
};

export default ApplicationTracking;
